var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "banner_height" }, [
        _c(
          "div",
          {
            class: _vm.searchBarFixed == true ? "ondown_banner" : "down_banner",
            attrs: { id: "searchBar" }
          },
          [
            _vm.isStatus != 1
              ? _c("div", { staticClass: "preview_bar" }, [
                  _c("a", {
                    staticClass: "down_close",
                    on: { click: _vm.goClose }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "4.48rem",
                        "line-height": "4.48rem",
                        "text-align": "center",
                        "font-size": "1.04rem",
                        color: "#C99700"
                      }
                    },
                    [_vm._v(" 此为临时链接，仅用于预览，将在短期内失效。")]
                  )
                ])
              : [
                  _c("div", { staticClass: "left_close" }, [
                    _c("a", {
                      staticClass: "down_close",
                      on: { click: _vm.goClose }
                    }),
                    _c("img", {
                      staticClass: "down_himg",
                      attrs: {
                        src: "/webAssets/images/img/newLogo.png",
                        alt: ""
                      }
                    })
                  ]),
                  _c(
                    "a",
                    { staticClass: "download", on: { click: _vm.goDown } },
                    [_vm._v(_vm._s(_vm.$t("topHeader.buttonText")))]
                  ),
                  _c("GCDOWN", {
                    attrs: { "down-show": _vm.DownShow },
                    on: { showDwon: _vm.getshowDonw }
                  }),
                  _c("GCGUIDE", {
                    attrs: {
                      "down-show": _vm.weiXin,
                      "img-type": _vm.$t("topHeader.shareImg")
                    },
                    on: { showDwon: _vm.getWechat }
                  })
                ]
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }